/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useState } from "react";
import ModalPortal from "components-new/ModalPortal";
import InputTemp from "components-new/InputTemp";
import TextArea from "components-new/Textarea";
import GroupCheck from "components-new/GroupCheck";
import { ITableDataModal } from "pages/StepPages/StepFour/One/Tables/models";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import sass from "./types.module.sass";
import { ChangeActiveTabContext } from "../TableNavigate";
import { snackWrapper } from "helpers";
import { RiskTypeResponse } from "libs/apiClient/data-contracts";
import { organizationAPI } from "libs/apiClient/Organization";

const initial: RiskTypeResponse = {
	id: 0,
	applicable: false,
	comment: "",
	type: "",
	consequences: "",
	name: "",
};

const TypesModal: React.FC<ITableDataModal<RiskTypeResponse>> = ({ toggle, replace, active, data, close }) => {
	const title = useMemo(() => {
		return `${toggle === "edit" ? "Редактирование: " : "Создание: "}Виды рисков (ущерба) и негативные последствия`;
	}, [toggle]);
	const [currentRisk, setCuurrentRisk] = useState<RiskTypeResponse>(initial);
	const { updateTabs } = useContext(ChangeActiveTabContext);

	useEffect(() => {
		if (active) {
			setCuurrentRisk(active);
		}
	}, [active]);

	const changeApplicable = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setCuurrentRisk((prevState) => ({ ...prevState, [name]: value !== "0" }));
	};
	const changeComment = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setCuurrentRisk((prevState) => ({ ...prevState, [name]: value }));
	};

	const save = () => {
		const { applicable, comment } = currentRisk;
		organizationAPI.objectRiskUpdate(currentRisk.id, { applicable, comment }).then(({ data: response }) => {
			const newData = [...data!].map((_) => (_.id === response.id ? currentRisk : _));
			replace(newData);
			setCuurrentRisk(initial);
			snackWrapper("success", "Таблица обновлена");
			updateTabs("RISK");
			close();
		});
	};

	return toggle !== null ? (
		<ModalPortal outSide={false} size={"md"} title={title} handleClose={close}>
			<div className={sass.modal}>
				<InputTemp
					options={data as []}
					onSelect={setCuurrentRisk}
					field={["type", "name"]}
					value={currentRisk?.type + " " + currentRisk?.name}
					label={"Условное обозначение риска (ущерба)"}
					required={true}
					search={true}
					type={"select"}
				/>
				<TextArea
					rows={10}
					readOnly={true}
					value={currentRisk?.consequences || ""}
					label={"Возможные типовые негативные последствия"}
				/>

				<GroupCheck.Wrapper required={true} label={"Оценка применимости"}>
					<GroupCheck.Item
						onChange={changeApplicable}
						checked={currentRisk.applicable !== null && !currentRisk.applicable}
						name={"applicable"}
						label={"Неприменимо"}
						value={"0"}
						type={"radio"}
					/>
					<GroupCheck.Item
						onChange={changeApplicable}
						checked={currentRisk.applicable !== null && currentRisk.applicable}
						name={"applicable"}
						label={"Применимо"}
						value={"1"}
						type={"radio"}
					/>
				</GroupCheck.Wrapper>
				<TextArea
					placeholder={"Введите комментарий"}
					onChange={changeComment}
					value={currentRisk?.comment || ""}
					name={"comment"}
					label={"Комментарий к оценке"}
					required={true}
				/>
				<div className={sass.btn}>
					<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button
						disabled={currentRisk.applicable === null || !currentRisk.comment}
						onClick={save}
						variant={BUTTON_VARIANTS.CONTAINED}>
						Сохранить
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

export default TypesModal;
